import { gql } from "@apollo/client";

export const GET_DROPOFF_PHOTO_URL = gql`
    query getDropoffPhotoUrl($sub_url: String!) {
        url: get_dropoff_photo_signed_url(sub_url: $sub_url)
    }
`;

export const GET_KYC_PHOTO_URL = gql`
    query getKycPhotoUrl($sub_url: String!) {
        url: get_kyc_photo_signed_url(sub_url: $sub_url)
    }
`;
